export const INITIAL_DATA_LOADED = 'INITIAL_DATA_LOADED';
export const SELECTION_CHANGED = 'SELECTION_CHANGED';
export const SET_PHOTOS_LOADING = 'SET_PHOTOS_LOADING';